module.exports = __webpack_public_path__ + "img/24h.5f940607.png";